import { Button } from "react-bootstrap";
import styles from "./BottomMenu.module.css";
import { ReactElement, useEffect, useState } from "react";
import checkAuthorization from "../../../utils/checkAuthorization/checkAuthorization";
import SourceInfo from "../SourceInfo/SourceInfo";
import { useSelector } from "react-redux";
import { RootState } from "../../../redux/store";
import deviceWidth from "../../../utils/getDeviceWidth/getDeviceWidth";

export interface IBottomMenuOptions {
  action: string;
  name: string;
  icon?: ReactElement<any, any>;
  onlyForAuthorized: boolean;
}

interface IBottomMenu {
  options: IBottomMenuOptions[];
  triggerAction: (action: string) => void;
  userId?: number;
  sourceUrl: string;
  imageUrl: string;
  username: string;
  isSplitViewDisabled: boolean;
}

const BottomMenu: React.FC<IBottomMenu> = (props) => {
  const [isAuthorized, setIsAuthorized] = useState(false);
  const [isExpanded, setIsExpanded] = useState(false);
  const [rightMargin, setRightMargin] = useState(0);
  const isMobile = useSelector((state: RootState) => state.client.isMobile);
  const pinImage = require("./elements/waitingPin.png");

  const triggerAction = (action: string) => {
    props.triggerAction(action);
    setIsExpanded(false);
  };

  const checkIsUserAuthorized = async () => {
    const authorized = await checkAuthorization({ strict: true, userId: props.userId });
    setIsAuthorized(authorized);
  };

  useEffect(() => {
    checkIsUserAuthorized();
  }, []);

  useEffect(() => {
    if (props.isSplitViewDisabled || !isMobile) {
      setRightMargin(0);
    } else {
      setRightMargin(deviceWidth() * 0.38);
    }
  }, [props.isSplitViewDisabled]);

  const areAllForAuthorized = (options: IBottomMenuOptions[]): boolean => {
    return options.every((option) => option.onlyForAuthorized);
  };

  return (
    <div className={styles.bottomMenu} style={{ right: rightMargin + "px" }}>
      {!isAuthorized && (
        <div className={styles.pinButtonContainer}>
          <Button variant="light" className={styles.pinButton} onClick={() => triggerAction("PIN")}>
            <img className={styles.pinImage} alt="p" src={pinImage} />
          </Button>
        </div>
      )}
      <div className={styles.sourceInfoContainer}>
        <SourceInfo sourceUrl={props.sourceUrl} imageUrl={props.imageUrl} username={props.username} />
      </div>
      <div className={styles.optionsContainer}>
        {isExpanded && (
          <div className={styles.buttonsColumn}>
            {props.options
              .filter(
                (option) =>
                  option.onlyForAuthorized !== undefined &&
                  (option.onlyForAuthorized === false || (option.onlyForAuthorized === true && isAuthorized)),
              )
              .map((option, index) => (
                <Button key={index} variant="dark" onClick={() => triggerAction(option.action)}>
                  {option.icon} {option.name}
                </Button>
              ))}
          </div>
        )}
      </div>
      <div className={styles.mainMenuButton}>
        {(isAuthorized || !areAllForAuthorized(props.options)) && (
          <Button onClick={() => setIsExpanded(!isExpanded)} variant="dark">
            <i className="bi bi-three-dots"></i>
          </Button>
        )}
      </div>
    </div>
  );
};

export default BottomMenu;
